import React, { useEffect, useState, useRef } from "react";
import { Modal, ModalTitle, ModalBody, ModalFooter } from "@vds/modals";
import styled from "styled-components";
import { Button } from "@vds/buttons";
import { Title } from "@vds/typography";
import { Line } from "@vds/lines";
import { Accordion, AccordionItem, AccordionHeader, AccordionDetail } from "@vds/accordions";
import { Icon } from "@vds/icons";
import * as Actions from "../../store/actions/billing/billing";
import { withRouter } from "../../withRouter";
import InvoicePayment from "../invoicePayment/invoicePayment";
import * as billing from "../../api/billing/index";
import * as account from "../../api/account/index";
import { connect, useSelector } from "react-redux";
import { DropdownSelect } from "@vds/selects";
import { Loader } from "@vds/loaders";
import { getAlertState, setAlertState, currencyFormatter, hasContractAccountDetails, updateNewRelicStatsFromSession } from "../../util/util";
import { addCurrencySymbol } from "../../util/negativeAmountHandler";
import * as StyledGlobalCSS from "../../constants/common/StyledGlobalConstants";
import * as StyledTableCSS from "../../constants/common/StyledTableConstants";
import FailedToLoadData from "../../pages/Login/failedToLoadData";
import * as GlobalActions from "../../store/actions/global/global";
import { useTranslation } from "react-i18next";
import { changeLanguageHandler } from "../../util/userLanguageUtils";
import { FlexRow, FlexColumn, Wrapper, ModalBox, CustomisedTitle } from "../../constants/common/StyledGlobalConstants";
import { getMonthAndDate } from "../../util/billingUtils";
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css"; //icons
import { pendoTrack, pendoTrackAutoPayDeenroll } from "../../util/pendoUtil";
import CPNotification from "../../pages/Login/CPNotification";
import * as InvoiceHistoryActions from "../../store/actions/billing/invoiceHistoryActions";
import * as PaymentHistoryActions from "../../store/actions/billing/paymentHistoryAction";
import InfoIcon from "../../assets/icons/InformationBW.png";
import { useInvoicePreviewOrDownload } from "../../hooks/useInvoicePreviewOrDownload";
import MultiCADueAmountNotification from "./MultiCADueAmountNotification";
import ManagePayment from "./ManagePayment ";
import AutoPay from "./AutoPay";
import EmptylistNotification from "./EmptylistNotification";
import SuspendedAccountNotification from "./SuspendedAccNotification";
import { DEVICE_BREAKPOINTS, suspendedFinancialStatuses, restorationFinancialStatuses, REDBALL_FEATURE_TOGGLE } from "../../constants/appConstants";
import { chatDisplayHandler } from "../../util/chatBotUtils";
import PropTypes from "prop-types";
import { INVOICE_HISTORY_CONSTANTS } from "../../constants/StringConstants";
const { TABLET, DESKTOP, LARGE_DESKTOP } = DEVICE_BREAKPOINTS;
const validFinancialStatuses = ["Active", "Reactivated"];

export const Spacer = styled.div`
  margin-top: ${(props) => (props.top ? props.top : "0px")};
  margin-bottom: ${(props) => (props.bottom ? props.bottom : "20px")};
  ${(props) => props.width && "width: " + props.width};
`;

const SpacedLine = () => (
  <Spacer top="8px" bottom="8px">
    <Line type="light"></Line>
  </Spacer>
);

const MicroTextWrapper = styled(Wrapper)`
  font-size: 0.625rem;
  margin: 0.2rem 0;
  @media (min-width: 768px) {
    font-size: 0.875rem;
    font-family: "neue-haas-grotesk-text";
    line-height: 20px;
    margin: unset;
  }
  @media (max-width: 767px) {
    font-size: 0.875rem;
    font-family: "neue-haas-grotesk-text";
    line-height: 20px;
    font-style: normal;
    margin: unset;
  }
`;

const DueByContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  width: auto;
  height: 20px;
`;

const SmallTextWrapper = styled(Wrapper)`
  font-size: 0.75rem;
  margin: 0.2rem 0;
  @media (min-width: 1024px) {
    font-size: 0.875rem;
    font-family: "neue-haas-grotesk-text";
    line-height: 20px;
    margin: unset;
  }
  @media (max-width: 1023px) {
    font-size: 0.875rem;
    font-family: "neue-haas-grotesk-text";
    line-height: 20px;
    margin: unset;
  }
`;

export const MediumTextWrapper = styled(Wrapper)`
  font-size: 0.875rem;
  margin: 0.2rem 0;
  @media (min-width: 768px) {
    font-size: 0.875rem;
    font-family: "neue-haas-grotesk-text";
    line-height: 20px;
    margin: unset;
  }
  @media (max-width: 767px) {
    font-size: 0.875rem;
    font-family: "neue-haas-grotesk-text";
    line-height: 20px;
    margin: unset;
  }
`;

const LargeTextWrapper = styled(Wrapper)`
  font-size: 1rem;
  margin: 0.2rem 0;
  @media (min-width: 1024px) {
    font-size: 0.875rem;
    font-family: "neue-haas-grotesk-text";
    line-height: 20px;
    margin: unset;
  }
  @media (max-width: 1023px) {
    font-size: 0.875rem;
    font-family: "neue-haas-grotesk-text";
    line-height: 20px;
    margin: unset;
    font-style: normal;
    font-weight: 400;
  }
`;

const BillingProfile = styled(Wrapper)`
  & h5 {
    font-size: 1.125rem;
  }
`;

const StyledRowColumn = styled(Wrapper)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  @media (max-width: 1023x) {
    flex-direction: column;
  }
`;

export const InvoiceTextLink = styled.a`
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
  font-family: neue-haas-grotesk-text;
  border-bottom: ${(props) => (props.disabled ? "none" : "0.0625rem solid")};
  border-color: #000000;
  margin: 0.2rem 0;
  color: ${(props) => (props.disabled ? "#bdbdbd" : "#0077b4")}; /* Change color when disabled */
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")}; /* Disable pointer events */

  @media (min-width: 1024px) {
    font-family: neue-haas-grotesk-text;
    font-size: 0.875rem;
    line-height: 20px;
    border-bottom: ${(props) => (props.disabled ? "none" : "1px solid")};
    border-color: #0077b4;
    margin: 0px;
    &:hover {
      border-width: 2px;
    }
    &:active {
      border-width: 1px;
    }
    &:focus {
      border-radius: 2px;
      outline: 2px solid #0077b4 !important;
    }
    ::after {
      border: none !important;
    }
  }

  @media (max-width: 1023px) {
    font-family: neue-haas-grotesk-text;
    font-size: 0.875rem;
    line-height: 20px;
    border-bottom: ${(props) => (props.disabled ? "none" : "1px solid")};
    border-color: #0077b4;
    color: ${(props) => (props.disabled ? "#bdbdbd" : "#0077b4")}; /* Change color when disabled */
    margin: 0px;
    &:hover {
      border-width: 2px;
    }
    &:active {
      border-width: 1px;
    }
    &:focus {
      border-radius: 2px;
      outline: 2px solid #0077b4 !important;
    }
    ::after {
      border: none !important;
    }
  }
`;

const LeftColumnAligned = styled(Wrapper)`
  width: 65%;
`;

const CustomLeftAligned = styled(Wrapper)`
  width: 65%;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

const RightColumnAligned = styled(Wrapper)`
  width: 35%;
  text-align: right;
`;

const CustomLeftRightColumnAligned = styled(Wrapper)`
  width: 35%;
  text-align: right;
  @media (max-width: 767px) {
    width: 100%;
    text-align: left;
  }
`;

const StyledAccordianHeader = styled(AccordionHeader)`
  & span {
    @media (min-width: 1024px) {
      margin-top: 1rem !important;
      margin-bottom: 1rem;
      padding: 0rem;
      padding-top: 1rem !important;
    }
    @media (max-width: 1023px) {
      margin-top: 1rem;
      margin-bottom: 1rem;
      padding: 0rem;
      padding-top: 1rem !important;
    }
  }
  & div {
    @media (max-width: 1023px) {
      margin-top: 1rem;
      margin-bottom: 1rem;
      padding: 0rem;
    }
  }
`;

const StyledAccordionItem = styled(AccordionItem)`
  border-bottom: unset;
  & div {
    @media (min-width: 1024px) {
      padding-bottom: 0px;
    }
  }
`;
const StyledAccordionDetail = styled(AccordionDetail)`
  @media (max-width: 1023px) {
    padding-bottom: 0px !important;
  }
`;

const CustomDropDown = styled(DropdownSelect)`
  & div {
    & label {
      & p {
        font-family: "neue-haas-grotesk-text";
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 8px;
      }
      margin-bottom: 0px;
    }
  }
  & span {
    & span {
      & div {
        height: 2.75rem;
        background: #ffffff;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        &:hover {
          border: ${(props) => (props.disabled ? "" : "1px solid black !important")};
          border-radius: ${(props) => (props.disabled ? "" : "4px")};
        }
        & span {
          top: 0.8rem;
          & svg {
            min-width: 0.75rem;
            max-width: 0.75rem;
          }
        }
      }
    }
  }
  & select {
    font-family: "neue-haas-grotesk-text";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
  }
`;

function QuickBillSummary(props) {
  // --- State Hooks ---
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [contractAccounts, setContractAccounts] = useState([]);
  const [isVEPSOpen, setIsVEPSOpen] = useState(false);
  const [token, setToken] = useState("");
  const [sessionId, setSessionId] = useState("");
  const [disablePayBill, setDisablePayBill] = useState(false);
  const [disablePaymentMethod, setDisablePaymentMethod] = useState(false);
  const [vepsURL, setVepsURL] = useState(getVepsURLOnLoad());
  const [loader, setLoader] = useState(false);
  const [showMessage, setShowMessage] = useState("");
  const [actionCode, setActionCode] = useState("");
  const [isAlertModal, setIsAlertModal] = useState(false);
  const [address, setAddress] = useState("");
  const [invoiceInfoFailureAlert, setInvoiceInfoFailureAlert] = useState(false);
  const [invoiceNumberForNotificationError, setInvoiceNumberForNotificationError] = useState("");
  const [isMultiCAOpen, setIsMultiCAOpen] = useState(false);
  const [multipleContract, setMultipleContract] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [autopay, setAutopay] = useState({ error: false, autoPayNotify: false });
  const [loadInvoiceDetail, setLoadInvoiceDetail] = useState(false);
  const [invoiceDetailsResponseData, setInvoiceDetailsResponseData] = useState([]);
  const { invoiceNumber, quickBillViewInvoiceError, handleInvoiceAction } = useInvoicePreviewOrDownload({
    setLoader: setLoader,
    accountNumber: props.accountNumber,
  });
  const [emptylistNotification, setEmptylistNotification] = useState(false);
  const [bannerStatus, setBannerStatus] = useState({
    showYellowBanner: false,
    showOrangeBannerForNAandApac: false,
    showOrangeBannerForEMEA: false,
    showBlueBanner: false,
    showMultiContractBillDueBanner: false,
    triggerPaymentStatusCall: false,
  });
  const [showNotification, setShowNotification] = useState(false);
  const mainContentRef = useRef(null);
  const [t, i18n] = useTranslation(["billingTranslation", "redBallTranslation"]);

  const { accountUserTokenDetails } = useSelector((state) => state.ACCOUNT);
  const isNACOUNTRY = accountUserTokenDetails?.isNA;
  const isAPACCOUNTRY = accountUserTokenDetails?.isAPAC;
  const isEMEACOUNTRY = accountUserTokenDetails?.isEMEA;
  const [invoiceResponse, setInvoiceResponse] = useState([]);
  const [invoiceState, setInvoiceState] = useState({
    isInvoiceEnable: null,
    invoiceAvailabledate: null,
  });

  const hasInvoiceEnabled = (invoiceResponse) => {
    // Filter the invoiceResponse to find the invoice with the matching invoice number
    const filteredData = invoiceResponse
      .filter((invoice) => invoice.invoiceNumber === props.quickBill.invoiceNumber)
      .map((invoice) => ({ invoiceAvailable: invoice.invoiceAvailable, invoiceAvailableDate: invoice.invoiceAvailableDate }));
    // Update the state based on the filtered result
    if (filteredData?.length) {
      setInvoiceState({
        isInvoiceEnable: filteredData[0].invoiceAvailable,
        invoiceAvailabledate: filteredData[0].invoiceAvailableDate,
      });
    } else {
      setInvoiceState({
        isInvoiceEnable: null,
        invoiceAvailabledate: null,
      });
    }
  };

  // --- Effects ---
  useEffect(() => {
    if (!loader && !loadInvoiceDetail && mainContentRef.current) {
      mainContentRef.current.focus();
      window.scrollTo(0, 0);
    }
  }, [loader, loadInvoiceDetail]);

  useEffect(() => {
    if (props.quickBill.invoiceNumber && invoiceResponse && invoiceResponse.length > 0) {
      hasInvoiceEnabled(invoiceResponse);
    }
  }, [invoiceResponse, props.quickBill.invoiceNumber]);

  useEffect(() => {
    // Delay rendering SuspendedAccountNotification by 3 seconds
    const timer = setTimeout(() => setShowNotification(true), 500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const updatePaymentStatus = async () => {
      let reqBody = {
        contractAccountId: props.contractAccount,
        paymentStatus: null,
      };
      try {
        const response = await account.updatePaymentStatusCall(reqBody);
        if (response?.data?.statusCode === "200") {
          console.log("updatePaymentStatus", response.data.paymentStatus);
        } else {
          console.log("Failed to update payment status:", response.data);
        }
      } catch (error) {
        console.log("Error in updatePaymentStatus:", error);
      }
    };

    if (bannerStatus.triggerPaymentStatusCall) {
      updatePaymentStatus();
    }
  }, [bannerStatus.triggerPaymentStatusCall]);

  useEffect(() => {
    if (quickBillViewInvoiceError) {
      window.scrollTo(0, 0);
      setInvoiceInfoFailureAlert(true);
      setInvoiceNumberForNotificationError(invoiceNumber);
      setTimeout(() => setInvoiceInfoFailureAlert(false), 5000);
    }
  }, [quickBillViewInvoiceError]);

  useEffect(() => {
    chatDisplayHandler(sessionStorage.getItem("currentPath"));
  }, []);

  useEffect(() => {
    i18n.changeLanguage(changeLanguageHandler(props.userLanguage));
  }, [props.userLanguage]);

  useEffect(() => {
    document.title = props.title;
  }, [props.title]);

  useEffect(() => {
    props.getInvoiceNumber("");
    setMultipleContract([]);
    if (props.accountId !== "") {
      handleGetContractAccount(props.contractAccount);
    }
    return () => {
      props.resetQuickBill();
      props.invoiceHistoryReset();
      props.paymentHistoryReset();
      document.documentElement.style.overflow = "scroll";
    };
  }, []);

    /* START - REDBALL CONFIG */

  useEffect(() => {
    if (REDBALL_FEATURE_TOGGLE) {
      // Extract the contractAccountId from props.erpBusinessPartner by matching props.contractAccount
      const selectedContractAccount = props.erpBusinessPartner?.data?.contractAccountDetails?.find(
        (item) => item.erpCANumber === props.contractAccount
      );
      const contractAccountId = selectedContractAccount?.contractAccountId;

      // Get the paymentStatus for the selected contractAccountId from props.paymentStatus
      const selectedPaymentStatus = props.paymentStatus?.data?.find((item) => item.contractAccountId === contractAccountId)?.paymentStatus;

      const isSuspended =
        suspendedFinancialStatuses.includes(props.accountFinancialStatus?.toLowerCase()) &&
        hasContractAccountDetails(props.erpBusinessPartner, props.contractAccount);
      const isRestored = restorationFinancialStatuses.includes(props.accountFinancialStatus?.toLowerCase());
      const isInRegion = isNACOUNTRY || isAPACCOUNTRY;
      const isInAnyRegion = isInRegion || isEMEACOUNTRY;

      // Set the banner status based on the selected paymentStatus
      setBannerStatus({
        showYellowBanner: isSuspended && selectedPaymentStatus === "true" && isInRegion,
        showOrangeBannerForNAandApac: isSuspended && selectedPaymentStatus !== "true" && isInRegion,
        showOrangeBannerForEMEA: isSuspended && selectedPaymentStatus !== "true" && !isInRegion,
        showBlueBanner: isRestored && isInAnyRegion,
        triggerPaymentStatusCall: isRestored && isInAnyRegion && (selectedPaymentStatus === "true" || selectedPaymentStatus === "false"),
      });
    }
  }, [props.paymentStatus, props.accountFinancialStatus, props.regionId, props.contractAccount, props.erpBusinessPartner]);

  /* END - REDBALL CONFIG */

  useEffect(() => {
    if (
      invoiceDetailsResponseData &&
      invoiceDetailsResponseData.length > 0 &&
      invoiceDetailsResponseData?.filter(
        (item) => item?.contractAccount !== props.contractAccount && item?.lastDueDate !== "" && item?.outStandingCharges !== "0"
      )?.length !== 0
    ) {
      setBannerStatus((prevState) => ({ ...prevState, showMultiContractBillDueBanner: true }));
      /* code added to add the pendo log when MultiContractBillDueBanner is getting diaplayed*/
      pendoTrack("Customer Portal | Billing And Payment | MultiContract Bill Due ", {
        Status: "MultiContract Bill Due Notification displayed",
        accountId: props.accountNumber,
      });
    }
  }, [invoiceDetailsResponseData]);

  // --- Helper Functions ---
  function addressBuilder(data) {
    return data.street + ", " + data.city + ", " + data.country + ", " + data.state + ", " + data.zipCode;
  }

  const handleGetContractAccount = (data) => {
    setLoader(true);
    if (!props.makePaymentHistoryCall) {
      props.invoiceHistoryReset();
      props.paymentHistoryReset();
    }
    let reqBody = {
      accId: props.accountId,
    };
    account
      .getContractAccountCall(reqBody)
      .then((response) => {
        setAlertState(false);
        if (response.data.data.length) {
          let contractAccount = response.data.data.filter((item) => item.contractAccountNumber === data);
          let contractAccountuuid = { getContractAccountCallResponse: response?.data?.data, uuid: contractAccount[0]?.uuid || "" };
          props.setContractAccountCallResponse(contractAccountuuid);
          let multipleCa = response.data.data;
          if (multipleContract.length === 0) {
            multipleCa = multipleCa
              .filter(
                (item) =>
                  // Either the item is the current contract account OR it has a valid financial status
                  item.contractAccountNumber === props.contractAccount || validFinancialStatuses.includes(item.financialStatus)
              )
              .map((item) => item.contractAccountNumber);
          }
          setMultipleContract(multipleCa);
          setContractAccounts(contractAccount);
          props.setContractAccounts(contractAccount);
          props.getContractId(contractAccount[0].contractAccountId);
          setAddress(addressBuilder(contractAccount[0]));
          handleQuickBillSummary(data, multipleCa, contractAccount[0].contractAccountId);
        } else {
          setAlertState(true);
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log("handleGetContractAccount", error);
        if (getAlertState() === false) {
          setAlertState(true);
          pendoTrack("Customer Portal | Billing And Payment | Failed To Load ", {
            status: "Unable to load data for billing and payment",
            statusCode: error?.response?.data?.statusCode,
            accountId: props.accountNumber,
          });
        }
        setLoader(false);
      });
  };

  const handleQuickBillSummary = (contract, contracts, contractAccountId) => {
    const quickBillCallback = (response) => {
      if (!response) {
        setLoader(false);
        setAlertState(true);
      } else if (!Object.keys(response).length) {
        setLoader(false);
        setEmptylistNotification(true);
      } else {
        const makePaymentUrl = props?.location?.state?.makePayment;
        if (makePaymentUrl || props?.location?.state?.managePayment) {
          if (response?.data.length) {
            makePayment(
              makePaymentUrl ? "makepayment" : "managewallet",
              props.invoiceNumber,
              response?.data[0]?.currencyCode,
              response?.data[0]?.companyCode
            );
          }
        }
        fetchInvoiceDetailsData(contracts);
        props.managePaymentsPermission ? handleAutoPayCheck() : setLoader(false);
      }
    };
    props.getQuickBill(contract, quickBillCallback);
  };

  const getOtherContractAccountDetails = (caNumber) => {
    setLoader(true);
    const callBack = (response) => {
      props.paymentHistoryReset();
      if (!response) {
        props.invoiceHistoryReset();
        setLoader(false);
        setAlertState(true);
      } else {
        const makePaymentUrl = props?.location?.state?.makePayment;
        if (makePaymentUrl || props?.location?.state?.managePayment) {
          if (response?.data.length) {
            makePayment(
              makePaymentUrl ? "makepayment" : "managewallet",
              props.invoiceNumber,
              response?.data[0]?.currencyCode,
              response?.data[0]?.companyCode
            );
          }
        }
        invoiceDetailsResponseData.forEach((contract) => {
          if (contract.contractAccount === caNumber) {
            let invoiceResponse = contract.invoiceHistory;
            props.loadData(caNumber, invoiceResponse);
          }
        });
        props.managePaymentsPermission ? handleAutoPayCheck() : setLoader(false);
      }
    };
    let contractAccount = props.contractAccountCallResponse.getContractAccountCallResponse.filter((item) => item.contractAccountNumber === caNumber);
    setContractAccounts(contractAccount);
    props.setContractAccounts(contractAccount);
    props.getContractId(contractAccount[0].contractAccountId);
    setAddress(addressBuilder(contractAccount[0]));
    props.setContractAccount(caNumber);
    setTabIndex(0);
    props.getQuickBill(caNumber, callBack);
  };

  const fetchInvoiceDetailsData = async (contracts) => {
    setLoadInvoiceDetail(true);
    setInvoiceDetailsResponseData([]);
    let invoiceData = [],
      contractDetails = [];
    contracts.map((item) => {
      let data = {
        contractAccount: item,
      };
      contractDetails.push(data);
    });
    try {
      const invoiceResponses = await Promise.all(
        contracts.map((item) =>
          billing.getInvoiceByContractAccountIdCall({
            contractAccount: item,
            regionId: props.regionId,
          })
        )
      );
      const invoiceDataResponse = await Promise.all(invoiceResponses.map((response) => response?.data?.data));
      invoiceData = invoiceDataResponse;
      let index = contracts.indexOf(props.contractAccount);
      invoiceData &&
        invoiceData.length !== 0 &&
        invoiceData.forEach((item, index) => {
          let lastDateVar = "";
          let dueCharges = 0;
          let filteredByDateStatus = item?.filter(
            (item) => (item.status === "Amount due" || item.status.toLowerCase().includes("unpaid")) && new Date(item?.dueDate) < new Date()
          );

          if (filteredByDateStatus && filteredByDateStatus.length !== 0) {
            filteredByDateStatus.sort(function (a, b) {
              let c = new Date(a["dueDate"]);
              let d = new Date(b["dueDate"]);
              return c - d;
            });
            lastDateVar = filteredByDateStatus[0].dueDate;
            dueCharges = filteredByDateStatus
              .map((item) => Number(item.totalAmountDue.replace(/,/g, "")))
              .reduce((item, currentValue) => {
                return currentValue > 0 ? item + currentValue : item;
              }, 0);
          }
          let invoiceHistoryData = invoiceResponses[index];
          contractDetails[index] = {
            ...contractDetails[index],
            lastDueDate: lastDateVar,
            invoiceHistory: invoiceHistoryData,
            outStandingCharges: currencyFormatter(String(dueCharges)),
          };
        });
      setIsMultiCAOpen(true);
      setInvoiceDetailsResponseData(contractDetails);
      let invoiceResponse = invoiceResponses[index];
      props.loadData(props.contractAccount, invoiceResponse);
      if (invoiceResponse?.data?.data) {
        setInvoiceResponse(invoiceResponse.data.data);
      }
      setLoadInvoiceDetail(false);
    } catch (error) {
      console.log("fetchInvoiceDetailsData", error);
      setLoadInvoiceDetail(false);
    }
  };

  const handleAutoPayCheck = () => {
    // Auto Pay Check API call
    !loader && setLoader(true);
    let reqBody = {
      contractAccountNumber: props.contractAccount,
    };
    account
      .autoPayCheckCall(reqBody)
      .then((response) => {
        if (response?.data?.statusCode === "200") {
          setAutopay({ error: false, autoPayNotify: !response?.data?.data?.autoPayFlag });
        } else {
          setAutopay({ error: true, autoPayNotify: false });
          console.log("Unable to fetch auto pay details due to an unexpected error");
        }
        setLoader(false);
      })
      .catch((error) => {
        setAutopay({ error: true, autoPayNotify: false });
        console.log("Unable to fetch auto pay details due to an unexpected error", error);
        setLoader(false);
      });
  };

  const makePayment = (action, invoiceNo, currencyCode = "", companyCode = "") => {
    updateNewRelicStatsFromSession();
    setLoader(true);
    if (props.invoiceNumber !== null && props.invoiceNumber === invoiceNo) {
      if (action === "managewallet") {
        setDisablePaymentMethod(true);
      } else if (action === "makepayment") {
        setDisablePayBill(true);
      }
    }
    setActionCode(action === "managewallet" ? "Manage Wallet" : "Make a Payment");
    let postObject = {
      businessPartnerId: props.businessPartnerNumber,
      contractAccountId: props.contractAccount,
      customerUserId: props.userId,
      actionCode: action,
      currencyCode: props.quickBill.currencyCode || currencyCode,
      companyCode: props.quickBill.companyCode || companyCode,
    };

    billing
      .getTokenCall(postObject)
      .then((response) => {
        setLoader(false);
        if (response.data.statusCode === "200") {
          setToken(response.data.data.encryptedData);
          setSessionId(response.data.data.sessionId);
          pendoTrack(`Customer Portal | Billing And Payment | ${action} `, {
            status: "Success",
            statusCode: response.data.statusCode,
            accountId: props.accountNumber,
          });
        } else {
          window.scrollTo(0, 0);
          setShowMessage(
            <StyledTableCSS.ErrorNotification
              title={t("Unable to redirect. Please try again later.")}
              onCloseButtonClick={() => setShowMessage("")}
              type="error"
              className="notificationErrMsg"
            ></StyledTableCSS.ErrorNotification>
          );
          setTimeout(() => {
            setShowMessage("");
            setDisablePaymentMethod(false);
            setDisablePayBill(false);
          }, 5000);
          pendoTrack(`Customer Portal | Billing And Payment | ${action} `, {
            status: "Failed",
            statusCode: response.data.statusCode,
            accountId: props.accountNumber,
          });
        }
      })
      .catch((error) => {
        setLoader(false);
        window.scrollTo(0, 0);
        setShowMessage(
          <StyledTableCSS.ErrorNotification
            title={t("Unable to redirect. Please try again later.")}
            onCloseButtonClick={() => setShowMessage("")}
            type="error"
            className="notificationErrMsg"
          ></StyledTableCSS.ErrorNotification>
        );
        setTimeout(() => {
          setShowMessage("");
          setDisablePaymentMethod(false);
          setDisablePayBill(false);
        }, 5000);
        pendoTrack(`Customer Portal | Billing And Payment | ${action} `, {
          status: "Failed",
          statusCode: error.response.data.statusCode,
          accountId: props.accountNumber,
        });
      });
  };

  let vepsTimeOut,
    interval = true;
  useEffect(() => {
    if (token !== "" && sessionId !== "") {
      initializeVEPS(token, sessionId);
    }

    return () => cleanupVEPS();
  }, [token, sessionId]);

  useEffect(() => {
    const VEPS_ORIGIN = process.env.REACT_APP_BASE_VEPS_URL
      ? new URL(process.env.REACT_APP_BASE_VEPS_URL).origin
      : "";
    const handleVepsMessage = (event) => {
      if (VEPS_ORIGIN && event.origin !== VEPS_ORIGIN) return;
      if (event.data && event.data.event === "AUTOPAY_DEENROLL_ATTEMPTED") {
        pendoTrackAutoPayDeenroll({
          contractAccountId: event.data.contractAccountId,
          businessPartnerId: event.data.businessPartnerId,
          companyCode: event.data.companyCode,
          countryCode: event.data.countryCode,
          paymentMethodType: event.data.paymentMethodType,
          paymentMethodLast4: event.data.paymentMethodLast4,
          sessionId: event.data.sessionId,
          attemptTimestamp: event.data.attemptTimestamp,
        });
      } else if (
        event.data &&
        event.data.event === "BUTTON_CLICKED" &&
        event.data.buttonId === "submit_transaction_btn"
      ) {
        pendoTrackAutoPayDeenroll({
          contractAccountId: event.data.contractAccountId,
          businessPartnerId: event.data.businessPartnerId,
          companyCode: event.data.companyCode,
          countryCode: event.data.countryCode,
          paymentMethodType: event.data.paymentMethodType,
          paymentMethodLast4: event.data.paymentMethodLast4,
          sessionId: event.data.sessionId,
          attemptTimestamp: event.data.timestamp,
        });
      }
    };
    window.addEventListener("message", handleVepsMessage);
    return () => window.removeEventListener("message", handleVepsMessage);
  }, []);

  const initializeVEPS = (token, sessionId) => {
    setIsVEPSOpen(true);
    props.setFooterEnabled(false);
    document.documentElement.style.overflow = "hidden";
    const vepsurl = vepsURL + token;
    setVepsURL(vepsurl);

    let timecounter = 0;
    const vepsTimeOutHandler = () => handleVEPSPaymentProcess(sessionId, timecounter, vepsurl);
    interval = setInterval(vepsTimeOutHandler, timecounter);
  };

  const cleanupVEPS = () => {
    if (vepsTimeOut) {
      clearInterval(vepsTimeOut);
      clearInterval(interval);
      vepsTimeOut = false;
      interval = false;
    }
  };

  const handleVEPSPaymentProcess = (sessionId, timecounter, vepsurl) => {
    clearInterval(interval);
    timecounter += 3000;

    const allPaymentStatusTrueForSuspendedAccounts = checkPaymentStatus(props);
    const paymentCall = getPaymentCall(sessionId, allPaymentStatusTrueForSuspendedAccounts);

    paymentCall.then((response) => handlePaymentSuccess(response, vepsurl)).catch(() => handlePaymentError());

    interval = setInterval(() => handleVEPSPaymentProcess(sessionId, timecounter, vepsurl), timecounter);
  };

  const checkPaymentStatus = (props) => {
    return (
      Array.isArray(props.paymentStatus?.data) &&
      props.paymentStatus.data
        .filter((item) => {
          const accountDetails = props.erpBusinessPartner?.data?.contractAccountDetails?.find(
            (account) => account.contractAccountId === item.contractAccountId
          );
          return accountDetails?.financialStatus?.toLowerCase() === "suspended";
        })
        .every((item) => item.contractAccountId === props.contractAccountId || item.paymentStatus === "true")
    );
  };

  const getPaymentCall = (sessionId, allPaymentStatusTrueForSuspendedAccounts) => {
    return bannerStatus.showOrangeBannerForNAandApac &&
      props.revealId != null &&
      allPaymentStatusTrueForSuspendedAccounts &&
      actionCode === "Make a Payment"
      ? billing.getPaymentProcessStatusCall(sessionId, props.revealId)
      : billing.getPaymentProcessStatusCall(sessionId);
  };

  const handlePaymentSuccess = (response, vepsurl) => {
    if (response.data.data.sessionStatus.toLowerCase() === "success") {
      if (actionCode === "Make a Payment") {
        props.getPaymentStatusSuccess({
          data: {
            ...props.paymentStatus,
            data: props.paymentStatus?.data?.map((item) =>
              item.contractAccountId === props.contractAccountId ? { ...item, paymentStatus: "true" } : item
            ),
          },
        });
        const allPaymentStatusTrueForSuspendedAccounts = checkPaymentStatus(props);
        if (bannerStatus.showOrangeBannerForNAandApac && props.revealId != null && allPaymentStatusTrueForSuspendedAccounts) {
          pendoTrack("Customer Portal | Billing And Payment | Make a Payment | Payment Process Suspended account", {
            status: "Success",
            statusCode: response.data.statusCode,
            universalAccountId: props.accountNumber,
            accountId: props.revealId,
          });
        } else {
          pendoTrack("Customer Portal | Billing And Payment | Make a Payment | Payment Process", {
            status: "Success",
            statusCode: response.data.statusCode,
            universalAccountId: props.accountNumber,
          });
        }
      }
      setAutopay({ error: false, autoPayNotify: false });
      handleAutoPayCheck();
      clearInterval(vepsTimeOut);
      clearInterval(interval);
      vepsTimeOut = false;
      interval = false;
      setTimeout(() => resetVEPSState(vepsurl), 3000);
    }
  };

  const handlePaymentError = () => {
    clearInterval(vepsTimeOut);
    clearInterval(interval);
    vepsTimeOut = false;
    interval = false;
  };

  const resetVEPSState = (vepsurl) => {
    document.documentElement.style.overflow = "scroll";
    setIsVEPSOpen(false);
    props.setFooterEnabled(true);
    setDisablePayBill(false);
    setDisablePaymentMethod(false);
    setVepsURL(getVepsURLOnLoad());
    setToken("");
    setSessionId("");
  };
  const closePayment = () => {
    document.documentElement.style.overflow = "scroll";
    setVepsURL(getVepsURLOnLoad());
    setToken("");
    setSessionId("");
    setIsVEPSOpen(false);
    props.setFooterEnabled(true);
    setDisablePayBill(false);
    setDisablePaymentMethod(false);
    setShowMessage("");

    // call Auto Pay Check API to check if Autopay status has been changed
    if (actionCode === "Manage Wallet") {
      setAutopay({ error: false, autoPayNotify: false });
      handleAutoPayCheck();
    }
  };

  function showBill(invoiceNo, contractAccount) {
    let action = {
      type: "ViewInvoice",
      sourceComponent: "quickBill",
    };
    handleInvoiceAction(invoiceNo, action, contractAccount);
  }

  const handleKeyDownInvoice = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      showBill(props.quickBill.invoiceNumber, props.contractAccount);
    }
  };

  function getVepsURLOnLoad() {
    const url = window.location.href.toString();
    if (
      url.includes("vccp-uat.ebiz.verizon.com") ||
      url.includes("reveal.stage.us.fleetmatics.com") ||
      url.includes("reveal.stage.us.vzconnect.com") ||
      url.includes("vccp-qa.ebiz.verizon.com") ||
      url.includes("vccp-dev.ebiz.verizon.com") ||
      url.includes("localhost") ||
      url.includes("reveal.stage.eu.fleetmatics.com") ||
      url.includes("reveal.stage.eu.vzconnect.com")
    ) {
      return "https://verizonpayment-sit1.verizon.com/revealPortal/?Reveal=";
    } else {
      return "https://verizonpayment.verizon.com/revealPortal/?Reveal=";
    }
  }

  const handleErrorModal = (value) => {
    setIsAlertModal(value);
  };

  const handleShowModal2 = (value) => {
    setShowModal2(value);
  };

  const handleShowModal = (value) => {
    setShowModal(value);
  };

  // --- UI Helper Functions ---
  const width = props.windowSize.width;
  const isTabletOrlarger = width >= TABLET;
  const isDesktopOrlarger = width >= DESKTOP;
  const isMobile = width < TABLET;
  const isDesktop = width < DESKTOP;
  const isBetweenDesktopAndLargeDesktop = () => {
    return isDesktopOrlarger && width < LARGE_DESKTOP;
  };
  const isMediumDesktop = isBetweenDesktopAndLargeDesktop();
  const billPaymentButtonStyle = width >= 860 && "flex-end";
  const windowWidth = width <= 847;
  const addressWidth = windowWidth ? "100%" : "37%";
  const contractAccountWidth = windowWidth && "100%";
  const excludeRegionIds = ["372", "250", "276", "528", "40", "56", "826"];
  const shouldShowButton = !excludeRegionIds.includes(props.regionId);
  const dueDateParts = getMonthAndDate(props.quickBill.dueDate) || [];
  const dueMonth = dueDateParts[0] || "";
  const dueDay = dueDateParts[1] || "";
  const noBannersVisible = !bannerStatus.showYellowBanner && !bannerStatus.showOrangeBannerForNAandApac && !bannerStatus.showOrangeBannerForEMEA;
  const bannerMarginTop = noBannersVisible ? "2rem" : "0rem";
  const isNarrowWindow = width >= 354 && width <= 600;
  const tooltipMarginLeft = isNarrowWindow ? "-6.5rem !important" : "";
  const isTableView = width >= 800 && width <= 900;
  const marginRightValue = isTableView ? "10px" : undefined;
  const hasViewPermission = props.viewInvoicesPermission !== "ReadOnly";
  const isMultiCAOpenLength = isMultiCAOpen && isMultiCAOpen.length !== 0;
  const notification = invoiceInfoFailureAlert || showMessage || props.downloadInvoiceError?.isError || props.viewInvoiceError?.isError;
  const showErrorMargin = notification || isMultiCAOpenLength;
  const wrappermarginTop = showErrorMargin || isMultiCAOpenLength ? "0rem" : "4rem";
  const multipleAccounts = contractAccounts.length > 1;
  const isDutchUser = props.userLanguage === "nl-NL";
  const shouldShowAutoPayBanner = bannerStatus.showBlueBanner && !bannerStatus.showMultiContractBillDueBanner;
  const shouldShowSuspendedBanner =
    bannerStatus.showYellowBanner || bannerStatus.showOrangeBannerForNAandApac || bannerStatus.showOrangeBannerForEMEA;
  const shouldShowSecondaryAutoPay = autopay.autoPayNotify && !bannerStatus.showMultiContractBillDueBanner;
  const shouldShowSuspendedNotification = !emptylistNotification && shouldShowSuspendedBanner;
  const shouldShowMultiCANotification = invoiceDetailsResponseData?.length > 0;

  const getMarginBottom = (tabletValue, mobileValue) => (isTabletOrlarger ? tabletValue : mobileValue);

  function getResponsiveConfig({ isMobile, isDesktop, isMediumDesktop, isDesktopOrlarger }) {
    const isTabletOrSmaller = isMobile || isMediumDesktop;

    return {
      alignSelf: isDesktop ? "flex-start" : "flex-end",
      wrapperWidth: isDesktop || isMobile ? "100%" : "50%",
      wrapperPaddingTop: isDesktop && "2rem",
      flexColumnWidth: isMobile ? "100%" : "",
      okButtonWidth: isMobile ? "100%" : "6.25rem",
      flexDisplay: isMobile ? "block" : "flex",
      buttonWidth: isMobile ? "100%" : "auto",
      flexDirection: isTabletOrSmaller ? "column" : "row",
      flexWrap: isTabletOrSmaller ? "wrap" : "nowrap",
      widthWrapper: isMobile ? "inherit" : "50%",
      marginTop: isMobile ? "1.5rem" : "0rem",
      alignItemsMobile: isMobile ? "auto" : "end",
      buttonMarginBottom: isDesktopOrlarger || isMediumDesktop ? "1rem" : "",
      spacerBottom: isDesktopOrlarger ? "20px" : "16px",
      buttonMarginRight: isMediumDesktop ? "0rem" : "1rem",
    };
  }

  const {
    flexWrap,
    marginTop,
    alignItemsMobile,
    buttonMarginBottom,
    spacerBottom,
    buttonMarginRight,
    widthWrapper,
    alignSelf,
    wrapperWidth,
    wrapperPaddingTop,
    flexColumnWidth,
    okButtonWidth,
    flexDisplay,
    buttonWidth,
    flexDirection,
  } = getResponsiveConfig({ isMobile, isDesktop, isMediumDesktop, isDesktopOrlarger });

  function getInvoiceErrorMessage() {
    if (invoiceInfoFailureAlert) {
      return t("Invoice No", { number: `${invoiceNumberForNotificationError}` });
    }
    if (showMessage) {
      return t("Unable to redirect. Please try again later.");
    }
    if (props.downloadInvoiceError?.isError) {
      return props.downloadInvoiceError.errorText;
    }
    if (props.viewInvoiceError?.isError) {
      return props.viewInvoiceError.errorText;
    }
    return null;
  }

  function handleModalClose(event) {
    if (invoiceInfoFailureAlert) {
      setInvoiceInfoFailureAlert(false);
      return;
    }
    if (showMessage) {
      setShowMessage("");
      return;
    }
    if (props.downloadInvoiceError?.isError) {
      props.setDownloadInvoiceError({
        isError: false,
        errorText: "",
        invoiceNumber: "",
      });
      return;
    }
    if (props.viewInvoiceError?.isError) {
      props.setViewInvoiceError({
        isError: false,
        errorText: "",
        invoiceNumber: "",
      });
      return;
    }
    event.preventDefault();
  }

  function renderScreenReaderAlerts() {
    if (!showNotification || loader || loadInvoiceDetail) return null;
    return (
      <div className="sr-only" tabIndex="-1" role="alert">
        {shouldShowSuspendedNotification && (
          <SuspendedAccountNotification
            invoiceNumber={props?.invoiceNumber}
            t={t}
            windowSize={props.windowSize}
            makePayment={makePayment}
            totalOutstandingCharges={props.quickBill?.totalOutstandingCharges}
            currencySymbol={props.currencySymbol}
            regionId={props.regionId}
            bannerStatus={bannerStatus}
            userLanguage={props.userLanguage}
            autoPayFlag={autopay}
            isSuspendedAccNotification={false}
          />
        )}
        {shouldShowMultiCANotification && (
          <MultiCADueAmountNotification
            t={t}
            responseData={invoiceDetailsResponseData}
            getOtherContractAccountDetails={getOtherContractAccountDetails}
          />
        )}
      </div>
    );
  }

  const renderDivider = () => {
    return isTabletOrlarger ? (
      <SpacedLine />
    ) : (
      <Wrapper marginBottom="1.5rem">
        <Line type="light" />
      </Wrapper>
    );
  };

  const renderVEPSPayment = () => (
    <ManagePayment closePayment={closePayment} actionCode={actionCode} vepsURL={vepsURL} windowSize={props.windowSize.width} />
  );

  const renderDutchNotice = () => (
    <>
      {`Ga naar `}
      <a
        id="refresh-page-link"
        type="standAlone"
        size="large"
        href={"https://reveal-help.verizonconnect.com/hc/articles/4408919391763"}
        aria-label="billing overview"
        target="_blank"
        style={{ color: "#0077B4" }}
      >
        {`Factureringsoverzicht`}
      </a>
      {` voor meer informatie.`}
    </>
  );

  const renderEnglishNotice = () => (
    <>
      {" "}
      {t("For more information, see")}{" "}
      <a
        id="refresh-page-link"
        type="standAlone"
        size="large"
        href={"https://reveal-help.verizonconnect.com/hc/articles/4408919391763"}
        aria-label="billing overview"
        target="_blank"
        style={{ color: "#0077B4" }}
      >
        {t("Billing overview")}
      </a>
      {`.`}
    </>
  );

  const renderNotification = () => (
    <Wrapper marginTop={wrappermarginTop} marginBottom="24px">
      <CPNotification isOpen={notification} notificationType="error" closeButton={true} width="auto" height="auto" onClose={handleModalClose}>
        <Wrapper style={{ textWrap: "balance" }} fontFamily>
          {getInvoiceErrorMessage()}
        </Wrapper>
      </CPNotification>
    </Wrapper>
  );

  function renderModalBox() {
    return (
      <ModalBox
        ariaLabel=""
        opened={isAlertModal}
        closeButton={
          <Wrapper onClick={handleErrorModal} marginRight="1rem" marginLeft="auto">
            <Icon name="close" size="medium" color="#000000" style={{ cursor: "pointer", float: "right" }} />
          </Wrapper>
        }
        disableOutsideClick={true}
        paddingTop="2rem"
        modalBodyPaddingTop="0rem"
        modalFooterPaddingTop="2.4rem"
        modalFooterWidth="65%"
        lineHeight="1.35rem"
        height="18rem"
        maxHeight="50vh"
        width="35rem"
        maxWidth="35rem"
        mobHeight="38vh"
        mobMaxHeight="70vh"
        mobWidth="85vw"
        mobMaxWidth="90vw"
        mobPaddingTop="2rem"
        mobBodyPaddingTop="0rem"
      >
        <ModalBody>
          <Wrapper style={{ paddingTop: wrapperPaddingTop }}>
            {t("We are unable to process your request for quick bill summary. Please try again.")}
          </Wrapper>
        </ModalBody>
        <ModalFooter>
          <Wrapper marginLeft="auto" width={flexColumnWidth}>
            <Button secondary size="large" onClick={() => setAlertState(false)} width={okButtonWidth}>
              {t("OK")}
            </Button>
          </Wrapper>
        </ModalFooter>
      </ModalBox>
    );
  }

  // Helper: Render contract account/address section for desktop
  function renderContractAccountSectionDesktop() {
    return (
      <FlexColumn marginRight={marginRightValue}>
        {multipleAccounts ? (
          <CustomDropDown
            label={t("Contract account")}
            onChange={(e) => {
              props.setContractAccount(e.target.value);
            }}
          >
            {contractAccounts.map((contract) => (
              <option key={contract.contractAccountNumber} value={contract.contractAccountNumber}>
                {contract.contractAccountNumber}
              </option>
            ))}
          </CustomDropDown>
        ) : (
          <div
            aria-describedby="AddressTitle CusAddress"
            style={{
              width: contractAccountWidth,
            }}
          >
            <MicroTextWrapper bold fontFamily id="AddressTitle" marginBottom="4px !important">
              {t("Contract account")}
            </MicroTextWrapper>
            {contractAccounts.map((contract) => (
              <LargeTextWrapper key={contract.contractAccountNumber}>{contract.contractAccountNumber}</LargeTextWrapper>
            ))}
          </div>
        )}
        <div>
          <MicroTextWrapper bold fontFamily marginTop="1rem !important" marginBottom="4px !important">
            {t("Address")}
          </MicroTextWrapper>
          <LargeTextWrapper id="CusAddress" size="large">
            {address}
          </LargeTextWrapper>
        </div>
      </FlexColumn>
    );
  }

  // Helper: Render contract account/address section for mobile
  function renderContractAccountSectionMobile() {
    return (
      <Wrapper width={widthWrapper}>
        <div>
          {multipleAccounts ? (
            <CustomDropDown
              label={t("Contract account")}
              onChange={(e) => {
                props.setContractAccount(e.target.value);
              }}
            >
              {contractAccounts.map((contract) => (
                <option key={contract.contractAccountNumber} value={contract.contractAccountNumber}>
                  {contract.contractAccountNumber}
                </option>
              ))}
            </CustomDropDown>
          ) : (
            <div>
              <MicroTextWrapper bold fontFamily>
                {t("Contract account")}
              </MicroTextWrapper>
              <Spacer bottom="4px" />
              {contractAccounts.map((contract) => (
                <LargeTextWrapper key={contract.contractAccountNumber}>{contract.contractAccountNumber}</LargeTextWrapper>
              ))}
            </div>
          )}
        </div>
        <div
          aria-describedby="AddressTitle CusAddress"
          style={{
            width: addressWidth,
            marginTop: "1rem",
          }}
        >
          <MicroTextWrapper bold fontFamily id="AddressTitle">
            {t("Address")}
          </MicroTextWrapper>
          <Spacer bottom="4px" />
          <LargeTextWrapper id="CusAddress" size="large">
            {address}
          </LargeTextWrapper>
        </div>
      </Wrapper>
    );
  }

  // Helper: Render payment buttons for desktop
  function renderPaymentButtonsDesktop() {
    if (!props.managePaymentsPermission) return null;
    return (
      <FlexColumn maxWidth={"100%"} display={flexDisplay} flexBasis={flexColumnWidth} marginTop={buttonMarginBottom}>
        <Wrapper flexWrap={flexWrap} style={{ display: "flex" }} flexDirection={flexDirection} justifyContent="flex-end">
          {shouldShowButton && (
            <StyledGlobalCSS.CPButton
              id="make-payment-button"
              buttonWidth={buttonWidth}
              ariaLabel="Make Payments"
              boxButton={true}
              style={{
                marginRight: buttonMarginRight,
                height: "2.5rem",
                marginBottom: buttonMarginBottom,
              }}
              disabled={disablePayBill}
              onClick={() => makePayment("makepayment", props.invoiceNumber)}
            >
              {t("MAKE A PAYMENT")}
            </StyledGlobalCSS.CPButton>
          )}
          <StyledGlobalCSS.CPButton
            id="manage-payment-button"
            buttonWidth={buttonWidth}
            ariaLabel="Manage Payment Methods"
            boxButton={true}
            style={{
              height: "2.5rem",
              marginTop: "0rem",
            }}
            secondary={true}
            disabled={disablePaymentMethod}
            onClick={() => makePayment("managewallet", props.invoiceNumber)}
          >
            {t("MANAGE PAYMENT METHODS")}
          </StyledGlobalCSS.CPButton>
        </Wrapper>
        <div
          style={{
            alignSelf,
            marginTop: "1rem",
          }}
        >
          <Wrapper
            id="PaymentNote"
            fontSize="0.75rem"
            style={{ fontFamily: "neue-haas-grotesk-text" }}
            textAlign={isDesktopOrlarger && "right"}
          >
            {t("BillPayment1")}
            <br /> {t("BillPayment2")}
          </Wrapper>
        </div>
      </FlexColumn>
    );
  }

  // Helper: Render payment buttons for mobile
  function renderPaymentButtonsMobile() {
    if (!props.managePaymentsPermission) return null;
    return (
      <FlexColumn maxWidth={flexColumnWidth} display="flex" flexBasis={flexColumnWidth}>
        <Wrapper
          marginTop={marginTop}
          display="flex"
          flexDirection="column"
          gap="16px"
          style={{
            alignItems: alignItemsMobile,
          }}
        >
          {shouldShowButton && (
            <StyledGlobalCSS.CPButton
              id="make-payment-button"
              buttonWidth={buttonWidth}
              ariaLabel="Make Payments"
              boxButton={true}
              fontSize="0.875rem"
              fontPaddingLeft="0px"
              fontPaddingRight="0px"
              style={{
                height: "2.5rem",
              }}
              disabled={disablePayBill}
              onClick={() => makePayment("makepayment", props.invoiceNumber)}
            >
              <SmallTextWrapper color="white" bold fontFamily>
                {t("Make Payments")}
              </SmallTextWrapper>
            </StyledGlobalCSS.CPButton>
          )}
          <StyledGlobalCSS.CPButton
            id="manage-payment-button"
            buttonWidth={buttonWidth}
            ariaLabel="Manage Payment Methods"
            boxButton={true}
            fontSize="0.875rem"
            fontPaddingLeft="0px"
            fontPaddingRight="0px"
            style={{
              height: "2.5rem",
            }}
            secondary={true}
            disabled={disablePaymentMethod}
            onClick={() => makePayment("managewallet", props.invoiceNumber)}
          >
            <SmallTextWrapper bold fontFamily>
              {t("Manage Payment Methods")}
            </SmallTextWrapper>
          </StyledGlobalCSS.CPButton>
        </Wrapper>
        <div
          style={{
            alignSelf: billPaymentButtonStyle,
            marginTop: "1rem",
          }}
        >
          <Wrapper
            id="PaymentNote"
            fontSize="0.75rem"
            fontWeight="400"
            style={{ fontFamily: "neue-haas-grotesk-text" }}
            textAlign={isTabletOrlarger && "right"}
          >
            {t("BillPayment1")}
            <br /> {t("BillPayment2")}
          </Wrapper>
        </div>
      </FlexColumn>
    );
  }

  function renderMainContent() {
    if (getAlertState()) {
      return <FailedToLoadData title={t("Billing and payment")} />;
    }
    if (loader || loadInvoiceDetail) {
      return <Loader active={true} fullscreen={true} />;
    }
    return (
      <React.Fragment>
        <div
          style={{ outline: "none" }}
          ref={mainContentRef}
          tabIndex={-1}
          aria-label="Billing and payment, View invoices, Make payments"
        >
          <div>{renderModalBox()}</div>
          {!emptylistNotification && (
            <>
              <h1 className="sr-only"> {t("Billing and payment")}</h1>
              <div aria-hidden={true}>
                <CustomisedTitle fontSize="40px" lineHeight="48px">
                  <Title size="large">{t("Billing and payment")}</Title>
                </CustomisedTitle>
              </div>
              {/* START - REDBALL CONFIG */}
              <>
                {shouldShowAutoPayBanner && (
                  <AutoPay
                    invoiceNumber={props?.invoiceNumber}
                    t={t}
                    makePayment={makePayment}
                    isAutoPayEnabled={!autopay.autoPayNotify}
                    restoredAccount={true}
                    contractAccountId={props.contractAccount}
                  />
                )}

                {!shouldShowAutoPayBanner && shouldShowSuspendedBanner && (
                  <SuspendedAccountNotification
                    invoiceNumber={props?.invoiceNumber}
                    t={t}
                    windowSize={props.windowSize}
                    makePayment={makePayment}
                    totalOutstandingCharges={props.quickBill?.totalOutstandingCharges}
                    currencySymbol={props.currencySymbol}
                    regionId={props.regionId}
                    bannerStatus={bannerStatus}
                    userLanguage={props.userLanguage}
                    autoPayFlag={autopay}
                    contractAccountId={props.contractAccount}
                  />
                )}
                {!shouldShowAutoPayBanner && !shouldShowSuspendedBanner && shouldShowSecondaryAutoPay && (
                  <AutoPay
                    invoiceNumber={props?.invoiceNumber}
                    t={t}
                    makePayment={makePayment}
                    autopay={autopay}
                    setAutoPay={setAutopay}
                    contractAccountId={props.contractAccount}
                  />
                )}
              </>
            </>
          )}
          {/* END - REDBALL CONFIG */}
          {shouldShowMultiCANotification && (
            <Wrapper marginTop={bannerMarginTop} marginBottom="24px">
              <MultiCADueAmountNotification
                t={t}
                responseData={invoiceDetailsResponseData}
                getOtherContractAccountDetails={getOtherContractAccountDetails}
              />
            </Wrapper>
          )}

          {emptylistNotification ? (
            <EmptylistNotification title={t("No invoices yet")}>
              {isDutchUser ? renderDutchNotice() : renderEnglishNotice()}
            </EmptylistNotification>
          ) : (
            <>
              {notification && renderNotification()}

              {isDesktopOrlarger ? (
                <FlexRow
                  style={{
                    marginTop: wrappermarginTop,
                    marginBottom: "1.7rem",
                  }}
                  flexWrap="nowrap"
                  justifyContent="space-between"
                >
                  {renderContractAccountSectionDesktop()}
                  {renderPaymentButtonsDesktop()}
                </FlexRow>
              ) : (
                <Wrapper
                  display="flex"
                  flexDirection={flexDirection}
                  flexWrap={flexWrap}
                  justifyContent="space-between"
                  gap="1rem"
                  style={{
                    marginTop: wrappermarginTop,
                  }}
                >
                  {renderContractAccountSectionMobile()}
                  <FlexRow justifyContent="space-between">
                    {renderPaymentButtonsMobile()}
                  </FlexRow>
                </Wrapper>
              )}

              <Modal ariaLabel="Modal" fullScreenDialog={false} hideCloseButton={false} opened={showModal2} onOpenedChange={handleShowModal2}>
                <ModalTitle>{t("Payment Options")}</ModalTitle>
                <ModalBody>{t("You will be redirected to Payment Hub...")}</ModalBody>
                <ModalFooter
                  buttonData={{
                    primary: {
                      children: t(`Confirm`),
                    },
                    close: {
                      children: t(`Cancel`),
                      onClick: () => setShowModal2(false),
                    },
                  }}
                />
              </Modal>

              <Modal ariaLabel="" opened={showModal} hideCloseButton={false} onOpenedChange={handleShowModal}>
                <ModalTitle></ModalTitle>
                <ModalBody></ModalBody>
              </Modal>

              <Spacer top="2.5rem" bottom="0rem">
                <Accordion id="BillingAccordion">
                  <StyledAccordionItem opened>
                    <AccordionHeader id="billsummaryheader" triggerType="icon">
                      <CustomisedTitle fontSize="32px" lineHeight="36px" style={{ wordBreak: "break-word", width: "95%" }}>
                        <Title size="large">{t("Bill summary")}</Title>
                      </CustomisedTitle>
                    </AccordionHeader>
                    <StyledAccordionDetail>
                      <Wrapper>
                        <StyledRowColumn>
                          <Wrapper width={wrapperWidth}>
                            <FlexColumn flexBasis="100%" maxWidth="100%" display="block">
                              <Spacer bottom="24px">
                                <Spacer bottom="4px">
                                  <MicroTextWrapper bold fontFamily>
                                    {t("Current bill")}
                                  </MicroTextWrapper>
                                </Spacer>
                                <CustomisedTitle fontSize="32px" lineHeight="36px">
                                  <Title size="large">{addCurrencySymbol(props.quickBill.totalCurrentCharges, props.currencySymbol)} </Title>
                                </CustomisedTitle>
                              </Spacer>

                              <Spacer bottom={spacerBottom}>
                                <FlexRow>
                                  <Wrapper marginRight="2.5rem">
                                    <FlexColumn>
                                      <DueByContainer>
                                        <MicroTextWrapper bold fontFamily marginBottom="4px !important">
                                          {t("Due by")}
                                        </MicroTextWrapper>
                                      </DueByContainer>
                                      <SmallTextWrapper fontFamily>{`${t(dueMonth)} ${dueDay}`}</SmallTextWrapper>
                                    </FlexColumn>
                                  </Wrapper>
                                  <Wrapper>
                                    <FlexColumn>
                                      <MicroTextWrapper bold fontFamily id="invoiceNumber" marginBottom="4px !important">
                                        {t("Invoice number")}

                                        <StyledGlobalCSS.CustomTooltip
                                          marginLeft="8px"
                                          left={tooltipMarginLeft}
                                          renderAnchorElement={() => (
                                            <StyledGlobalCSS.StyledImage width="1rem" height="1rem" src={InfoIcon} alt="help" />
                                          )}
                                        >
                                          {!invoiceState.isInvoiceEnable
                                            ? `${INVOICE_HISTORY_CONSTANTS.AVAILABLE_ON} ${invoiceState.invoiceAvailabledate}.`
                                            : t("Click on the invoice number to view the invoice. Click on the download icon to download a copy.")}
                                        </StyledGlobalCSS.CustomTooltip>
                                      </MicroTextWrapper>
                                      {hasViewPermission ? (
                                        <InvoiceTextLink
                                          style={{ width: "fit-content", cursor: "pointer" }}
                                          id="quick-bill-view-invoice"
                                          size="small"
                                          type="standAlone"
                                          aria-labelledby="invoiceNumber"
                                          tabIndex={invoiceState.isInvoiceEnable ? "0" : "-1"}
                                          onClick={() => showBill(props.quickBill.invoiceNumber, props.contractAccount)}
                                          onKeyDown={handleKeyDownInvoice}
                                          disabled={!invoiceState.isInvoiceEnable}
                                        >
                                          {props.quickBill.invoiceNumber}
                                        </InvoiceTextLink>
                                      ) : (
                                        <SmallTextWrapper fontFamily>{props.quickBill.invoiceNumber}</SmallTextWrapper>
                                      )}
                                    </FlexColumn>
                                  </Wrapper>
                                </FlexRow>
                              </Spacer>
                            </FlexColumn>
                          </Wrapper>
                          <Wrapper className="quick-bill-summary" width={wrapperWidth}>
                            <FlexColumn flexBasis="100%" maxWidth="100%" display="block">
                              <Wrapper aria-label="Bill summary">
                                <FlexRow marginBottom="0.25rem">
                                  <LeftColumnAligned>
                                    <Spacer bottom="0px">
                                      <MediumTextWrapper bold fontFamily>
                                        {t("Summary")}
                                      </MediumTextWrapper>
                                    </Spacer>
                                  </LeftColumnAligned>
                                  {isTabletOrlarger && (
                                    <RightColumnAligned>
                                      <MicroTextWrapper bold fontFamily>
                                        {t("Currency")}: {props.quickBill.currency}
                                      </MicroTextWrapper>
                                    </RightColumnAligned>
                                  )}
                                </FlexRow>
                                {isMobile && (
                                  <FlexRow marginBottom={"1rem"}>
                                    <LeftColumnAligned>
                                      <MicroTextWrapper bold fontFamily>
                                        {t("Currency")}: {props.quickBill.currency}
                                      </MicroTextWrapper>
                                    </LeftColumnAligned>
                                  </FlexRow>
                                )}

                                <FlexRow marginBottom={getMarginBottom("0.25rem", "1rem")}>
                                  <CustomLeftAligned>
                                    <MicroTextWrapper fontFamily>{t("Prior charges (including past due amounts)")}</MicroTextWrapper>
                                  </CustomLeftAligned>
                                  <CustomLeftRightColumnAligned>
                                    <MicroTextWrapper fontFamily>
                                      {addCurrencySymbol(props.quickBill.priorCharges, props.currencySymbol)}
                                    </MicroTextWrapper>
                                  </CustomLeftRightColumnAligned>
                                </FlexRow>

                                <FlexRow marginBottom={getMarginBottom("0.25rem", "1rem")}>
                                  <CustomLeftAligned>
                                    <MicroTextWrapper fontFamily>{t("Unapplied payments and adjustments")}</MicroTextWrapper>
                                  </CustomLeftAligned>

                                  <CustomLeftRightColumnAligned>
                                    <MicroTextWrapper fontFamily>
                                      {addCurrencySymbol(props.quickBill.unappliedPaymentsAndAdjustments, props.currencySymbol)}
                                    </MicroTextWrapper>
                                  </CustomLeftRightColumnAligned>
                                </FlexRow>
                                {renderDivider()}

                                <FlexRow marginBottom="1.5rem">
                                  <CustomLeftAligned>
                                    <Spacer bottom="0rem">
                                      <MicroTextWrapper bold fontFamily>
                                        {t("Total outstanding charges")}
                                      </MicroTextWrapper>
                                    </Spacer>
                                  </CustomLeftAligned>

                                  <CustomLeftRightColumnAligned>
                                    <MicroTextWrapper bold fontFamily>
                                      {addCurrencySymbol(props.quickBill.totalOutstandingCharges, props.currencySymbol)}
                                    </MicroTextWrapper>
                                  </CustomLeftRightColumnAligned>
                                </FlexRow>

                                <FlexRow marginBottom={getMarginBottom("0.25rem", "1rem")}>
                                  <CustomLeftAligned>
                                    <MicroTextWrapper bold fontFamily>
                                      {t("Total current charges due by")} {`${t(dueMonth)} ${dueDay}`}
                                    </MicroTextWrapper>
                                  </CustomLeftAligned>

                                  <CustomLeftRightColumnAligned>
                                    <MicroTextWrapper bold fontFamily>
                                      {addCurrencySymbol(props.quickBill.totalCurrentCharges, props.currencySymbol)}
                                    </MicroTextWrapper>
                                  </CustomLeftRightColumnAligned>
                                </FlexRow>

                                <FlexRow marginBottom={getMarginBottom("0.25rem", "1rem")}>
                                  <CustomLeftAligned>
                                    <MicroTextWrapper fontFamily>{t("Monthly recurring charges")}</MicroTextWrapper>
                                  </CustomLeftAligned>

                                  <CustomLeftRightColumnAligned>
                                    <MicroTextWrapper fontFamily>
                                      {addCurrencySymbol(props.quickBill.monthlyRecurringCharges, props.currencySymbol)}
                                    </MicroTextWrapper>
                                  </CustomLeftRightColumnAligned>
                                </FlexRow>

                                <FlexRow marginBottom={getMarginBottom("0.25rem", "1rem")}>
                                  <CustomLeftAligned>
                                    <MicroTextWrapper fontFamily>{t("Professional services")}</MicroTextWrapper>
                                  </CustomLeftAligned>

                                  <CustomLeftRightColumnAligned>
                                    <MicroTextWrapper fontFamily>
                                      {addCurrencySymbol(props.quickBill.professionalServices, props.currencySymbol)}
                                    </MicroTextWrapper>
                                  </CustomLeftRightColumnAligned>
                                </FlexRow>

                                <FlexRow marginBottom={getMarginBottom("0.25rem", "1rem")}>
                                  <CustomLeftAligned>
                                    <MicroTextWrapper fontFamily>{t("Equipment charges")}</MicroTextWrapper>
                                  </CustomLeftAligned>

                                  <CustomLeftRightColumnAligned>
                                    <MicroTextWrapper fontFamily>
                                      {addCurrencySymbol(props.quickBill.equipmentCharges, props.currencySymbol)}
                                    </MicroTextWrapper>
                                  </CustomLeftRightColumnAligned>
                                </FlexRow>

                                <FlexRow marginBottom={getMarginBottom("0.25rem", "1.5rem")}>
                                  <CustomLeftAligned>
                                    <MicroTextWrapper fontFamily>{t("Tax")}</MicroTextWrapper>
                                  </CustomLeftAligned>

                                  <CustomLeftRightColumnAligned>
                                    <MicroTextWrapper fontFamily>
                                      {addCurrencySymbol(props.quickBill.taxesAndSurcharges, props.currencySymbol)}
                                    </MicroTextWrapper>
                                  </CustomLeftRightColumnAligned>
                                </FlexRow>
                                {renderDivider()}

                                <FlexRow marginBottom={getMarginBottom("2.5rem", "17px")}>
                                  <CustomLeftAligned>
                                    <Spacer bottom="0rem">
                                      <MicroTextWrapper bold fontFamily>
                                        {t("Account balance")}
                                      </MicroTextWrapper>
                                    </Spacer>
                                  </CustomLeftAligned>

                                  <CustomLeftRightColumnAligned>
                                    <MicroTextWrapper bold fontFamily>
                                      {addCurrencySymbol(props.quickBill.totalAmountDue, props.currencySymbol)}
                                    </MicroTextWrapper>
                                  </CustomLeftRightColumnAligned>
                                </FlexRow>
                              </Wrapper>
                            </FlexColumn>
                          </Wrapper>
                        </StyledRowColumn>
                      </Wrapper>
                    </StyledAccordionDetail>
                  </StyledAccordionItem>
                  <div></div>
                </Accordion>
              </Spacer>
            </>
          )}
        </div>
        {!emptylistNotification && <InvoicePayment makePayment={makePayment} {...props} tabIndex={tabIndex} setTabIndex={setTabIndex} />}
      </React.Fragment>
    );
  }

  return (
    <>
      {renderScreenReaderAlerts()}
      {isVEPSOpen ? renderVEPSPayment() : <BillingProfile>{renderMainContent()}</BillingProfile>}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    viewInvoicesPermission: state.ACCOUNT.viewInvoicesPermission,
    invoiceNumber: state.BILLING.invoiceNumber,
    accountId: state.ACCOUNT.account_id,
    contractAccounts: state.BILLING.contractAccounts,
    quickBill: state.BILLING.quickBill,
    contractAccount: state.BILLING.contractAccount,
    userName: state.ACCOUNT.userName,
    businessPartnerNumber: state.ACCOUNT.businessPartnerNumber,
    userId: state.ACCOUNT.userId,
    managePaymentsPermission: state.ACCOUNT.managePaymentsPermission,
    bannerDisplayOnLanding: state.ACCOUNT.bannerDisplayOnAll,
    windowSize: state.ACCOUNT.windowSize,
    regionId: state.ACCOUNT.regionId,
    accountNumber: state.ACCOUNT.accountNumber,
    currencySymbol: state.BILLING.currencySymbol,
    userLanguage: state.ACCOUNT.userLanguage,
    downloadInvoiceError: state.INVOICE.downloadInvoiceError,
    viewInvoiceError: state.INVOICE.viewInvoiceError,
    contractAccountCallResponse: state.BILLING.contractAccountCallResponse,
    makePaymentHistoryCall: state.PAYMENTHISTORY.makePaymentHistoryCall,
    isFooterEnabled: state.BILLING.isFooterEnabled,
    accountFinancialStatus: state.ACCOUNT.accountFinancialStatus,
    paymentStatus: state.ACCOUNT.paymentStatus,
    contractAccountId: state.BILLING.contractId,
    erpBusinessPartner: state.ACCOUNT.erpBusinessPartner,
    revealId: state.ACCOUNT.accountUserTokenDetails.accountId,
  };
};
QuickBillSummary.propTypes = {
  // Redux/parent props
  accountNumber: PropTypes.string,
  contractAccount: PropTypes.string,
  accountId: PropTypes.string,
  businessPartnerNumber: PropTypes.string,
  userId: PropTypes.string,
  userLanguage: PropTypes.string,
  contractAccountCallResponse: PropTypes.object,
  erpBusinessPartner: PropTypes.object,
  paymentStatus: PropTypes.object,
  quickBill: PropTypes.object,
  invoiceNumber: PropTypes.string,
  viewInvoicesPermission: PropTypes.string,
  managePaymentsPermission: PropTypes.bool,
  regionId: PropTypes.string,
  title: PropTypes.string,
  location: PropTypes.object,
  revealId: PropTypes.string,
  accountFinancialStatus: PropTypes.string,
  makePaymentHistoryCall: PropTypes.bool,
  contractAccountId: PropTypes.string,
  currencySymbol: PropTypes.string,
  // Functions
  getInvoiceNumber: PropTypes.func,
  resetQuickBill: PropTypes.func,
  invoiceHistoryReset: PropTypes.func,
  paymentHistoryReset: PropTypes.func,
  setContractAccountCallResponse: PropTypes.func,
  setContractAccounts: PropTypes.func,
  getContractId: PropTypes.func,
  setContractAccount: PropTypes.func,
  getQuickBill: PropTypes.func,
  loadData: PropTypes.func,
  setFooterEnabled: PropTypes.func,
  windowSize: PropTypes.shape({
    width: PropTypes.number,
  }),
  downloadInvoiceError: PropTypes.shape({
    isError: PropTypes.bool,
    errorText: PropTypes.string,
    invoiceNumber: PropTypes.string,
  }),
  viewInvoiceError: PropTypes.shape({
    isError: PropTypes.bool,
    errorText: PropTypes.string,
    invoiceNumber: PropTypes.string,
  }),
  setDownloadInvoiceError: PropTypes.func,
  setViewInvoiceError: PropTypes.func,
  getPaymentStatusSuccess: PropTypes.func,
};

export default withRouter(
  connect(mapStateToProps, {
    getContractId: Actions.getContractId,
    getInvoiceNumber: Actions.getInvoiceNumber,
    getQuickBill: Actions.getQuickBill,
    setContractAccount: Actions.setContractAccount,
    resetQuickBill: Actions.resetQuickBill,
    setContractAccounts: Actions.setContractAccounts,
    getBannerMessage: GlobalActions.getBannerMessage,
    setDownloadInvoiceError: InvoiceHistoryActions.setDownloadInvoiceError,
    setViewInvoiceError: InvoiceHistoryActions.setViewInvoiceError,
    setContractAccountCallResponse: Actions.setContractAccountCallResponse,
    getQuickBillSuccess: Actions.getQuickBillSuccess,
    loadData: InvoiceHistoryActions.loadData,
    invoiceHistoryReset: InvoiceHistoryActions.reset,
    paymentHistoryReset: PaymentHistoryActions.reset,
    setFooterEnabled: Actions.setFooterEnabled,
    getPaymentStatus: GlobalActions.getPaymentStatus,
    getPaymentStatusSuccess: GlobalActions.getPaymentStatusSuccess,
  })(QuickBillSummary)
);